function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Emitter } from '@bydesign-ui/hooks';
import { getDefaultElementPosition, getDefaultOverflowBoundaries, getDocScroll, getZIndex } from '@bydesign-ui/hooks';
import { Drag } from '../../../models/drag';
export function getDefaultScrollableBoundaries() {
  return {
    left: 10,
    right: 10,
    top: 10,
    bottom: 10
  };
}
export function getDefaultScrollDirection() {
  return [null, null];
}
export var Draggable = function (_Emitter) {
  _inherits(Draggable, _Emitter);

  var _super = _createSuper(Draggable);

  function Draggable() {
    var _this;

    _classCallCheck(this, Draggable);

    _this = _super.call(this);
    _this.container = document.body;
    _this.drag = new Drag();
    _this.direction = 'auto';
    _this.overflow = true;
    _this.overflowBoundaries = getDefaultOverflowBoundaries();
    _this.scrollable = true;
    _this.scrollableBoundaries = getDefaultScrollableBoundaries();
    _this.scrollableDelay = 10;
    _this.scrollStep = 3;
    _this.autoFlow = true;
    _this.dragOpacity = 0.5;
    _this.dragZIndex = getZIndex();
    _this.scrollableTimeId = 0;
    _this.scrollTimeId = 0;
    _this.scrollDirection = getDefaultScrollDirection();
    _this.isStartScroll = false;
    _this.dragType = 'copy';
    _this.dragging = false;

    _this.init();

    return _this;
  }

  _createClass(Draggable, [{
    key: "updateDraggableOptions",
    value: function updateDraggableOptions(options) {
      var draggable = options.draggable,
          trigger = options.trigger,
          data = options.data,
          getContainer = options.getContainer,
          _options$direction = options.direction,
          direction = _options$direction === void 0 ? 'auto' : _options$direction,
          _options$overflow = options.overflow,
          overflow = _options$overflow === void 0 ? true : _options$overflow,
          _options$overflowBoun = options.overflowBoundaries,
          overflowBoundaries = _options$overflowBoun === void 0 ? getDefaultOverflowBoundaries() : _options$overflowBoun,
          _options$scrollable = options.scrollable,
          scrollable = _options$scrollable === void 0 ? true : _options$scrollable,
          _options$scrollableBo = options.scrollableBoundaries,
          scrollableBoundaries = _options$scrollableBo === void 0 ? getDefaultScrollableBoundaries() : _options$scrollableBo,
          _options$scrollableDe = options.scrollableDelay,
          scrollableDelay = _options$scrollableDe === void 0 ? 10 : _options$scrollableDe,
          _options$scrollStep = options.scrollStep,
          scrollStep = _options$scrollStep === void 0 ? 3 : _options$scrollStep,
          _options$autoFlow = options.autoFlow,
          autoFlow = _options$autoFlow === void 0 ? true : _options$autoFlow,
          _options$dragOpacity = options.dragOpacity,
          dragOpacity = _options$dragOpacity === void 0 ? 0.5 : _options$dragOpacity,
          _options$dragZIndex = options.dragZIndex,
          dragZIndex = _options$dragZIndex === void 0 ? getZIndex() : _options$dragZIndex,
          getDragType = options.getDragType,
          dragLimit = options.dragLimit;
      this.drag.updateOptions({
        draggable: draggable,
        trigger: trigger,
        data: data,
        dragLimit: dragLimit
      });
      this.direction = direction;
      this.overflow = overflow;
      this.overflowBoundaries = overflowBoundaries;
      this.scrollable = scrollable;
      this.scrollableBoundaries = scrollableBoundaries;
      this.scrollableDelay = scrollableDelay;
      this.scrollStep = scrollStep;
      this.autoFlow = autoFlow;
      this.dragOpacity = dragOpacity;
      this.dragZIndex = dragZIndex;
      this.getDragType = getDragType;
      this.getContainer = getContainer;
    }
  }, {
    key: "updateTarget",
    value: function updateTarget(ele) {
      if (ele !== this.drag.getElem()) {
        this.drag.init(ele);
      }
    }
  }, {
    key: "getActionEle",
    value: function getActionEle() {
      return this.actionEle || null;
    }
  }, {
    key: "getTarget",
    value: function getTarget() {
      return this.drag.getElem() || null;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.cancelDrag();
      this.drag.removeAllListeners();
      this.drag.dispose();
    }
  }, {
    key: "handleDragPrepare",
    value: function handleDragPrepare(e) {
      var target = e.target;
      var container = this.getContainer && this.getContainer(e);

      if (container == null) {
        this.cancelDrag();
        return;
      }

      var startPos = this.startPos = {
        targetPos: Draggable.getOffsetPosition(target),
        containerPos: Draggable.getOffsetPosition(this.container)
      };
      this.container = container;
      this.dragging = true;
      this.dragType = this.getDragType(e);
      this.emit('drag-prepare', _objectSpread(_objectSpread({}, e), {}, {
        dragType: this.dragType,
        offset: {
          x: 0,
          y: 0
        },
        startPos: startPos
      }));
    }
  }, {
    key: "handleDragStart",
    value: function handleDragStart(e) {
      var dragOpacity = this.dragOpacity,
          dragType = this.dragType,
          dragZIndex = this.dragZIndex,
          startPos = this.startPos,
          dragging = this.dragging;

      if (!dragging) {
        return;
      }

      this.createActionEle(e.target);

      if (!this.actionEle || !startPos) {
        this.cancelDrag();
        return;
      }

      Object.assign(this.actionEle.style, {
        position: 'absolute',
        opacity: dragOpacity,
        top: startPos.targetPos.top,
        left: startPos.targetPos.left
      });

      if (dragType !== 'move-self') {
        Object.assign(this.actionEle.style, {
          zIndex: dragZIndex
        });
      }

      this.emit('drag-start', _objectSpread(_objectSpread({}, e), {}, {
        dragType: dragType,
        offset: {
          x: 0,
          y: 0
        },
        startPos: startPos
      }));
    }
  }, {
    key: "handleDragging",
    value: function handleDragging(e) {
      var startMousePos = e.startMousePos,
          currentMousePos = e.currentMousePos;
      var autoFlow = this.autoFlow,
          dragType = this.dragType,
          startPos = this.startPos,
          dragging = this.dragging;

      if (!dragging) {
        this.cancelDrag();
        return;
      }

      if (!startPos) {
        console.warn('startPos does not exist');
        this.cancelDrag();
        return;
      }

      var offset = this.calcTargetOffset(startPos, startMousePos, currentMousePos);
      this.emit('dragging', _objectSpread(_objectSpread({}, e), {}, {
        dragType: dragType,
        offset: offset,
        startPos: startPos
      }));

      if (autoFlow && this.actionEle) {
        Draggable.setOffset(this.actionEle, offset);
      }

      if (!this.scrollable) {
        return;
      }

      var scrollDir = this.detectScroll(e);

      if (scrollDir == null) {
        this.abortScrollableTime();
        this.scrollDirection = getDefaultScrollDirection();
      } else if (this.scrollDirection.join('-') !== scrollDir.join('-')) {
        this.abortScrollableTime();
        this.scrollDirection = scrollDir;
        this.startScrollableTime();
      }
    }
  }, {
    key: "handleDragEnd",
    value: function handleDragEnd(e) {
      var startMousePos = e.startMousePos,
          currentMousePos = e.currentMousePos;
      var startPos = this.startPos;

      if (!startPos) {
        console.warn('startPos does not exist');
        this.cancelDrag();
        return;
      }

      var offset = this.calcTargetOffset(startPos, startMousePos, currentMousePos);
      this.cancelDrag();
      this.emit('drag-end', _objectSpread(_objectSpread({}, e), {}, {
        dragType: this.dragType,
        startPos: startPos,
        offset: offset
      }));
    }
  }, {
    key: "getDragType",
    value: function getDragType(e) {
      throw new Error('you must provide the `getDragType` option');
    }
  }, {
    key: "createActionEle",
    value: function createActionEle(target) {
      var dragType = this.dragType;

      var _window$getComputedSt = window.getComputedStyle(target),
          width = _window$getComputedSt.width,
          height = _window$getComputedSt.height;

      if (dragType === 'move-self') {
        this.actionEle = target;
        this.startStyle = this.actionEle.style.cssText;
      } else {
        this.emit('before-create-action-ele', this);
        this.actionEle = target.cloneNode(true);
        document.body.appendChild(this.actionEle);

        if (dragType === 'move') {
          this.startStyle = this.actionEle.style.cssText;
          Object.assign(target.style, {
            display: 'none'
          });
        }
      }

      Object.assign(this.actionEle.style, {
        width: width,
        height: height
      });
    }
  }, {
    key: "disposeActionEle",
    value: function disposeActionEle() {
      if (this.actionEle) {
        if (this.dragType !== 'move-self') {
          this.actionEle.parentNode && this.actionEle.parentNode.removeChild(this.actionEle);
        }

        if (this.dragType !== 'copy') {
          var target = this.getTarget();

          if (target) {
            target.style.cssText = this.startStyle || '';
          }
        }
      }

      this.actionEle = undefined;
    }
  }, {
    key: "cancelDrag",
    value: function cancelDrag() {
      this.dragging = false;
      this.disposeActionEle();
      this.startStyle = '';
      this.actionEle = undefined;
      this.startPos = undefined;
    }
  }, {
    key: "calcTargetOffset",
    value: function calcTargetOffset(startPos, startMousePos, currentMousePos) {
      var direction = this.direction,
          overflow = this.overflow,
          overflowBoundaries = this.overflowBoundaries;
      var targetPos = startPos.targetPos,
          containerPos = startPos.containerPos;
      var offset = {
        x: 0,
        y: 0
      };
      var x = targetPos.left + (currentMousePos.pageX - startMousePos.pageX);
      var y = targetPos.top + (currentMousePos.pageY - startMousePos.pageY);

      if (!overflow) {
        y = Math.min(Math.max(containerPos.top + (overflowBoundaries.top || 0), y), containerPos.bottom - (overflowBoundaries.bottom || 0) - targetPos.height);
        x = Math.min(Math.max(containerPos.left + (overflowBoundaries.left || 0), x), containerPos.right - (overflowBoundaries.right || 0) - targetPos.width);
      }

      switch (direction) {
        case 'horizontal':
          offset.x = x;
          break;

        case 'vertical':
          offset.y = y;
          break;

        default:
          offset = {
            x: x,
            y: y
          };
          break;
      }

      return offset;
    }
  }, {
    key: "init",
    value: function init() {
      var _this2 = this;

      this.drag.addListener('drag-prepare', function (e) {
        return _this2.handleDragPrepare(e);
      });
      this.drag.addListener('drag-start', function (e) {
        return _this2.handleDragStart(e);
      });
      this.drag.addListener('dragging', function (e) {
        return _this2.handleDragging(e);
      });
      this.drag.addListener('drag-end', function (e) {
        return _this2.handleDragEnd(e);
      });
    }
  }, {
    key: "abortScrollableTime",
    value: function abortScrollableTime() {
      if (this.scrollableTimeId) {
        clearTimeout(this.scrollableTimeId);
        this.scrollableTimeId = 0;

        if (this.isStartScroll) {
          this.isStartScroll = false;
          this.containerScrollAbort();
          this.emit('scroll-end');
        }
      }
    }
  }, {
    key: "startScrollableTime",
    value: function startScrollableTime() {
      var _this3 = this;

      this.scrollableTimeId = window.setTimeout(function () {
        _this3.abortScrollableTime();

        _this3.isStartScroll = true;

        _this3.containerScroll();

        _this3.emit('scroll-start', _this3.scrollDirection);
      }, this.scrollableDelay);
    }
  }, {
    key: "containerScroll",
    value: function containerScroll() {
      var _this4 = this;

      var _this$scrollDirection = _slicedToArray(this.scrollDirection, 2),
          horizontalDir = _this$scrollDirection[0],
          verticalDir = _this$scrollDirection[1];

      this.scrollTimeId = window.setInterval(function () {
        var scrollTop = _this4.container.scrollTop || 0;
        var scrollLeft = _this4.container.scrollLeft || 0;
        var x = 0;
        var y = 0;

        if (horizontalDir != null) {
          x = (horizontalDir === 'left' ? -1 : 1) * _this4.scrollStep;
        }

        if (verticalDir != null) {
          y = (verticalDir === 'top' ? -1 : 1) * _this4.scrollStep;
        }

        _this4.container.scrollTo({
          left: scrollLeft + x,
          top: scrollTop + y
        });
      }, 16.6);
    }
  }, {
    key: "containerScrollAbort",
    value: function containerScrollAbort() {
      if (this.scrollTimeId) {
        clearInterval(this.scrollTimeId);
        this.scrollTimeId = 0;
      }
    }
  }, {
    key: "detectScroll",
    value: function detectScroll(e) {
      var _e$currentMousePos = e.currentMousePos,
          pageX = _e$currentMousePos.pageX,
          pageY = _e$currentMousePos.pageY;
      var direction = this.direction,
          scrollable = this.scrollable,
          _this$scrollableBound = this.scrollableBoundaries,
          _this$scrollableBound2 = _this$scrollableBound.left,
          left = _this$scrollableBound2 === void 0 ? 10 : _this$scrollableBound2,
          _this$scrollableBound3 = _this$scrollableBound.top,
          top = _this$scrollableBound3 === void 0 ? 10 : _this$scrollableBound3,
          _this$scrollableBound4 = _this$scrollableBound.right,
          right = _this$scrollableBound4 === void 0 ? 10 : _this$scrollableBound4,
          _this$scrollableBound5 = _this$scrollableBound.bottom,
          bottom = _this$scrollableBound5 === void 0 ? 10 : _this$scrollableBound5,
          container = this.container;

      if (!scrollable) {
        return null;
      }

      var containerPos = this.startPos && this.startPos.containerPos || Draggable.getOffsetPosition(container);
      var horizontalDir = null;
      var verticalDir = null;

      if (pageY - containerPos.top <= top && pageY - containerPos.top >= 0) {
        verticalDir = 'top';
      } else if (containerPos.bottom - pageY <= bottom && containerPos.bottom - pageY >= 0) {
        verticalDir = 'bottom';
      }

      if (pageX - containerPos.left <= left && pageX - containerPos.left >= 0) {
        horizontalDir = 'left';
      } else if (containerPos.right - pageX <= right && containerPos.right - pageX >= 0) {
        horizontalDir = 'right';
      }

      switch (direction) {
        case 'horizontal':
          return horizontalDir == null ? null : [horizontalDir, null];

        case 'vertical':
          return verticalDir == null ? null : [null, verticalDir];

        default:
          return horizontalDir == null && verticalDir == null ? null : [horizontalDir, verticalDir];
      }
    }
  }], [{
    key: "getOffsetPosition",
    value: function getOffsetPosition(ele, offsetEle) {
      var _ele$getBoundingClien = ele.getBoundingClientRect(),
          left = _ele$getBoundingClien.left,
          top = _ele$getBoundingClien.top,
          width = _ele$getBoundingClien.width,
          height = _ele$getBoundingClien.height;

      var _getDocScroll = getDocScroll(),
          scrollTop = _getDocScroll.scrollTop,
          scrollLeft = _getDocScroll.scrollLeft;

      var res = _objectSpread(_objectSpread({}, getDefaultElementPosition()), {}, {
        width: width,
        height: height
      });

      if (offsetEle) {
        var _offsetEle$getBoundin = offsetEle.getBoundingClientRect(),
            offsetEleLeft = _offsetEle$getBoundin.left,
            offsetEleTop = _offsetEle$getBoundin.top;

        res.left = offsetEleLeft - left;
        res.top = offsetEleTop - top;
      } else {
        res.left = left + scrollLeft;
        res.top = top + scrollTop;
      }

      res.right = res.left + width;
      res.bottom = res.top + height;
      return res;
    }
  }, {
    key: "setOffset",
    value: function setOffset(ele, offset) {
      var x = offset.x,
          y = offset.y;

      var _window$getComputedSt2 = window.getComputedStyle(ele),
          position = _window$getComputedSt2.position,
          styleLeft = _window$getComputedSt2.left,
          styleTop = _window$getComputedSt2.top;

      if (position === 'static') {
        ele.style.position = 'relative';
      }

      var _Draggable$getOffsetP = Draggable.getOffsetPosition(ele),
          offsetLeft = _Draggable$getOffsetP.left,
          offsetTop = _Draggable$getOffsetP.top;

      if (x != null) {
        ele.style.left = "".concat((parseFloat(styleLeft || '0') || 0) + (x - offsetLeft), "px");
      }

      if (y != null) {
        ele.style.top = "".concat((parseFloat(styleTop || '0') || 0) + (y - offsetTop), "px");
      }
    }
  }]);

  return Draggable;
}(Emitter);